import { useId, useState } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { ToggleGroup } from '@ui/kit';
import { textCorrectionInput } from '@utils/component-framework';
import { SizeTransition } from '@utils/react';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useTaskContext } from '../../context.js';
import { FacitInput } from './input.facit.js';
import { wrapper, toggle, transitionWrapper, crossfadeDurationMs, container } from './organism.facit-container.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function FacitContainer(props) {
  const context = useTaskContext();
  const id = useId();
  const [tab, setTab] = useState("answer");
  const input = props.task.content[0];
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => textCorrectionInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[input?.id ?? props.task.id])
  });
  if (!input) {
    return null;
  }
  const facit = "expectedText" in input.validation ? input.validation.expectedText : inputEntry?.validationType === "without-start-comma" ? input.validation.withoutStartComma : input.validation.withStartComma;
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    "data-tab": tab,
    "data-with-tabs": context === "facit",
    children: [context === "facit" && /*#__PURE__*/jsx("div", {
      className: toggle,
      children: /*#__PURE__*/jsx(ToggleGroup, {
        baseId: id,
        label: "V\xE6lg visningstilstand",
        onTabClick: setTab,
        selectedTabId: tab,
        tabs: [{
          id: "answer",
          title: "Mit svar"
        }, {
          id: "facit",
          title: "Rigtigt svar"
        }]
      })
    }), /*#__PURE__*/jsx(TransitionGroup, {
      component: "div",
      className: transitionWrapper,
      children: /*#__PURE__*/jsx(SizeTransition, {
        axis: "vertical",
        swappable: true,
        classNames: container,
        timeout: crossfadeDurationMs,
        children: ref => /*#__PURE__*/jsx("div", {
          className: container,
          ref: ref,
          children: /*#__PURE__*/jsx(FacitInput, {
            taskEntryKey: props.taskEntryKey,
            input: input,
            entry: tab === "answer" ? inputEntry : {
              type: "text-correction",
              validationType: "with-start-comma",
              ...inputEntry,
              text: facit
            },
            entryType: tab === "answer" ? "user-entry" : "should-have"
          })
        })
      }, tab)
    })]
  });
}

export { FacitContainer };
//# sourceMappingURL=organism.facit-container.js.map
